package one.healthium.fodmap

import co.touchlab.kermit.Logger
import co.touchlab.kermit.platformLogWriter
import one.healthium.fodmap.di.initKoin
import one.healthium.intercom.IntercomPlatform
import one.healthium.logger.SentryLogWriter
import one.healthium.logger.enableSentry
import one.healthium.logger.setupJsErrorHandlers
import one.primehealth.analytics.AppAnalyticsPlatform
import one.primehealth.app.BaseAppConfig
import one.primehealth.app.Flavour

actual object AppInit {
    fun init(flavour: Flavour) {
        setupLogger(flavour)

        val koinApplication = initKoin(
            flavour = flavour
        )
        val baseAppConfig = koinApplication.koin.get<BaseAppConfig>()
        IntercomPlatform.init(baseAppConfig)
        koinApplication.koin.get<AppAnalyticsPlatform>() // create instance
    }

    private fun setupLogger(flavour: Flavour) {
        setupJsErrorHandlers()
        enableSentry(BuildKonfig.BUILD_FLAVOUR)
        if (flavour == Flavour.Prod) {
            Logger.setLogWriters(SentryLogWriter())
        } else {
            Logger.setLogWriters(platformLogWriter(), SentryLogWriter())
        }
    }
}